import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import { IonApp, setupIonicReact } from "@ionic/react";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
// import { ApplicationInsights } from "@microsoft/applicationinsights-web";
// import {
// 	AppInsightsContext,
// 	ReactPlugin,
// } from "@microsoft/applicationinsights-react-js";
/* Theme variables */
import "./theme/variables.css";
import "./theme/main.css";
import {
	BarcodePage,
	DetailsPage,
	EditPage,
	LandingPage,
	ManagementPage,
	SignIn,
} from "./pages";
import { ProtectedRoute } from "./components";

import {
	SearchPage,
	SearchResultDetailPage,
	SearchResults,
} from "./pages/search";
import { SearchProvider } from "./context/search.context";
import { DebugPage } from "./pages/debug";
import { SettingsPage } from "./pages/settings";
import { AuthProvider } from "./context";

setupIonicReact();

// var reactPlugin = new ReactPlugin();
// var appInsights = new ApplicationInsights({
// 	config: {
// 		connectionString: process.env.REACT_APP_INSTRUMENTATION_KEY,
// 		enableAutoRouteTracking: true,
// 		extensions: [reactPlugin],
// 	},
// });
// appInsights.loadAppInsights();

const API_HOST = process.env.REACT_APP_API_HOST;

function App() {
	return (
		<IonApp>
			<AuthProvider>
				<SearchProvider>
					<HashRouter>
						<Switch>
							<Route exact path="/edit/:barcode/:blobid">
								{(props: any) => {
									const {
										location,
										match: {
											params: { barcode, blobid },
										},
									} = props;
									const externalPath =
										new URLSearchParams(
											location.search
										).get("externalPath");
									const isOcr =
										new URLSearchParams(
											location.search
										).get("isOcr") === "true";
									return (
										<ProtectedRoute>
											<EditPage
												barcode={barcode}
												blobId={blobid}
												externalPath={externalPath}
												isOcr={isOcr}
											/>
										</ProtectedRoute>
									);
								}}
							</Route>
							<Route exact path="/barcode">
								<ProtectedRoute>
									<BarcodePage />
								</ProtectedRoute>
							</Route>
							<Route exact path="/details/:id">
								<ProtectedRoute>
									<DetailsPage />
								</ProtectedRoute>
							</Route>
							<Route
								exact
								path="/search-detail/:barcode"
								render={function (props) {
									const {
										location,
										match: {
											params: { barcode },
										},
									} = props;
									const searchIndex =
										new URLSearchParams(
											location.search
										).get("searchIndex") ?? "-1";
									const searchId = new URLSearchParams(
										location.search
									).get("searchId");
									return (
										<ProtectedRoute>
											<SearchResultDetailPage
												barcode={barcode}
												searchId={searchId}
												searchIndex={searchIndex}
											/>
										</ProtectedRoute>
									);
								}}
							/>
							<Route exact path="/search-results">
								<ProtectedRoute>
									<SearchResults />
								</ProtectedRoute>
							</Route>
							<Route exact path="/search">
								<ProtectedRoute>
									<SearchPage />
								</ProtectedRoute>
							</Route>
							<Route exact path="/">
								<Redirect to="/landing" />
							</Route>
							<Route exact path="/landing">
								<ProtectedRoute>
									<LandingPage />
								</ProtectedRoute>
							</Route>
							<Route exact path="/management">
								<ProtectedRoute>
									<ManagementPage />
								</ProtectedRoute>
							</Route>
							<Route exact path="/debug">
								<DebugPage />
							</Route>
							<Route exact path="/signin">
								{(props) => (
									<SignIn history={props.history} />
								)}
							</Route>
							<Route exact path="/settings">
								<SettingsPage />
							</Route>
						</Switch>
					</HashRouter>
				</SearchProvider>
			</AuthProvider>
		</IonApp>
	);
}

export default App;
